import { bicyclePedestrianMainComponent } from './bicycle-pedestrian-main.component';

export const bicyclePedestrianMain = angular
.module('components.transportationALternative.bicyclePedestrian.bicyclePedestrianMain', [])
.component("bicyclePedestrianMain", bicyclePedestrianMainComponent)
.name;


// WEBPACK FOOTER //
// ./src/app/components/transportation-alternative/bicycle-pedestrian/bicycle-pedestrian-main/bicycle-pedestrian-main.module.js